import { render, staticRenderFns } from "./KwicHeader.vue?vue&type=template&id=f1a12308&"
import script from "./KwicHeader.vue?vue&type=script&lang=js&"
export * from "./KwicHeader.vue?vue&type=script&lang=js&"
import style0 from "./KwicHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports